const ME_REQUEST = 'platfi-ui-app/USER/ME_REQUEST';
const ME_SUCCESS = 'platfi-ui-app/USER/ME_SUCCESS';
const ME_FAILURE = 'platfi-ui-app/USER/ME_FAILURE';

const PATCH_PREFERENCES = 'platfi-ui-app/USER/PATCH_PREFERENCES';
const PATCH_PREFERENCES_SUCCESS = 'platfi-ui-app/USER/PATCH_PREFERENCES_SUCCESS';
const PATCH_PREFERENCES_FAILURE = 'platfi-ui-app/USER/PATCH_PREFERENCES_FAILURE';

const patchUserPreferences = {
  request: PATCH_PREFERENCES,
  success: PATCH_PREFERENCES_SUCCESS,
  failure: PATCH_PREFERENCES_FAILURE,
};

export { ME_REQUEST, ME_SUCCESS, ME_FAILURE, patchUserPreferences };
